import BasicLayout from "@/layouts/basic-layout";

const meta = {
    auth: false,
    cache: false,
};
export default {
    path: "/trainExamManager",
    name: "trainExamManager",
    redirect: {
        name: "trainExamManager",
    },
    meta,
    component: BasicLayout,
    children: [{
            path: "/trainExamManager/trainPlan1/:queryType",
            name: "trainPlanList",
            meta: {
                ...meta,
                title: "培训计划",
            },
            component: () => import("@/pages/trainExamManager/trainPlan/index.vue"),
        },
        {
            path: "/trainExamManager/trainPlan2/:queryType",
            name: "trainPlanListTeacher",
            meta: {
                ...meta,
                title: "讲师培训计划",
            },
            component: () => import("@/pages/trainExamManager/trainPlan/index.vue"),
        },
        {
            path: "/trainExamManager/trainPlan/add",
            name: "trainPlanAdd",
            meta: {
                ...meta,
                title: "新建培训计划",
            },
            component: () => import("@/pages/trainExamManager/trainPlan/addTrain.vue"),
        },
        {
            path: "/trainExamManager/trainPlan/edit",
            name: "trainPlanEdit",
            meta: {
                ...meta,
                title: "编辑培训计划",
            },
            component: () => import("@/pages/trainExamManager/trainPlan/addTrain.vue"),
        },
        {
            path: "/trainExamManager/trainPlan/detail",
            name: "trainPlanDetail",
            meta: {
                ...meta,
                title: "查看培训计划",
            },
            component: () => import("@/pages/trainExamManager/trainPlan/trainDetail.vue"),
        },
        {
            path: "/trainExamManager/myTrain/list",
            name: "myTrainList",
            meta: {
                ...meta,
                title: "我的培训",
            },
            component: () => import("@/pages/trainExamManager/myTrain/index.vue"),
        },
        {
            path: "/trainExamManager/myTrain/detail",
            name: "myTrainDetail",
            meta: {
                ...meta,
                title: "培训详情",
            },
            component: () => import("@/pages/trainExamManager/myTrain/detail.vue"),
        },
    ],
};